import 'vite/modulepreload-polyfill';
import { createApp, onMounted, ref } from 'vue';

import * as DataDogLogs from '~/lib/datadog/datadog';

import { BaseSection } from './base-section';

export default class CollectionFaqs extends BaseSection {
  constructor() {
    super('[data-section-type="collection-faqs"]');
  }

  init(instanceData) {
    const container = instanceData.container;

    if (!container) {
      DataDogLogs.error(
        '[Allbirds section] - Collection FAQS - init - Container not found',
        {},
        new Error('Container not found'),
      );
      return;
    }

    createApp({
      name: 'CollectionFaqsSection',
      setup() {
        const openFaqs = ref({});

        const toggleFaq = (index) => {
          openFaqs.value[index] = !openFaqs.value[index];
        };

        const isOpen = (index) => {
          return openFaqs.value[index];
        };

        onMounted(() => {});

        return {
          isOpen,
          openFaqs,
          toggleFaq,
        };
      },
    }).mount(container);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionFaqs();
});
